import { IIconStyles, PrimaryButton } from '@fluentui/react';
import { IToggleButtonStyles } from '../../../data-types/styles/site-header/IToggleButtonStyles';
import { SiteHeaderIconToggleButton } from './SiteHeaderIconToggleButton';

export interface ISiteHeaderToggleButtonProps {
    label: string;
    onClick: (ev?: React.MouseEvent<any> | React.KeyboardEvent<any>) => void;
    id?: string;
    isOpenState?: boolean;
    children?: React.ReactNode;
    toggleButtonStyles?: IToggleButtonStyles;
    iconStyles?: IIconStyles;
}

export function SiteHeaderToggleButton(props: ISiteHeaderToggleButtonProps) {
    const label = props.isOpenState ? `Close ${props.label}` : `Open ${props.label}`;

    if (props.isOpenState) {
        const { children, isOpenState, ...rest } = props;
        return <SiteHeaderIconToggleButton {...rest} iconName="" isOpenState={true} />;
    } else {
        return (
            <PrimaryButton
                id={props.id}
                title={label}
                ariaLabel={label}
                styles={props.toggleButtonStyles?.darkClose}
                onClick={props.onClick}
            >
                {props.children}
            </PrimaryButton>
        );
    }
}
